import "./styles/tokens.css";
import "./styles/global.css";
import { track } from "./client/analytics";

const path = window.location.pathname;

// 표준 퍼널의 진입 두 개는 라우팅 이전에 발화한다 — `/`는 edge가 직접 서빙하므로
// 서버측 `landing.viewed`가 구조적으로 발화할 수 없다(2026-08-11 실측).
track("app_open", { route: path.startsWith("/r/") ? "/r/:token" : path.startsWith("/challenge/")?"/challenge/:token":path }, true);
if (path === "/") track("landing_view", {}, true);
if (path.startsWith("/r/")) {
  import("./public-vanilla").then(({ mountPublicRsvp }) => mountPublicRsvp());
} else if (path.startsWith("/guide/") || path === "/privacy" || path === "/terms" || path === "/support" || path === "/changelog" || path.startsWith("/c/")) {
  import("./public-pages").then(({ mountPublicPage }) => mountPublicPage());
} else {
  import("./app-bootstrap").then(({ mountApp }) => mountApp());
}
